export const posts = [
  {
    id: 1,
    date: 'May 2026',
    title: 'We Are Building Something Lasting',
    excerpt:
      'We are proud to announce the official launch of our community communication hub for the Armenian Community Center and School project.',
    body: `Dear Members of Our Community,

We are proud to formally announce the launch of this page — our dedicated communication hub for the Armenian Community Center and School project in Redmond, Washington.

This is not just a construction project. It is a statement of who we are as a community and what we want to pass on to the next generation. Our school has served Armenian families across the greater Seattle area for decades, and today our growing student population and the needs of our community demand more space, more resources, and a more permanent home.

[IMAGE:/images/update1-img1-new.png|Community Center exterior rendering next to the church]

**What We Are Building**

The expansion will significantly enlarge school facilities for growing enrollment and offer a more comprehensive Armenian education. It will also create a multipurpose community events venue — a banquet and concert hall for weddings, cultural celebrations, community gatherings, and major events that today we must hold elsewhere.

This will be a space that belongs to all of us.

[IMAGE:/images/update1-img2-new.png|Aerial view of the Community Center and church campus with expanded parking]

**Why This Page Exists**

We believe that a project of this scale must be built not only with bricks and mortar, but with transparency and trust. This page is our commitment to keeping you informed every step of the way — from planning and permits to groundbreaking and completion.

Here you will find:
• Regular project updates as milestones are reached
• A clear picture of our finances — what has been raised, what has been spent, and what remains
• Opportunities to contribute your time, skills, or financial support
• Answers to your questions through our upcoming FAQ section

**How You Can Help**

This project belongs to the community — and its success depends on the community. Whether you can volunteer your time, donate your professional skills, or contribute financially, every act of support brings us closer to the finish line. Details on how to get involved will be published here soon.

We are grateful for your trust, your patience, and your partnership. We will update this page regularly and will always be honest with you about where things stand.

[IMAGE:/images/update1-img3-new.jpg|First floor plan showing classrooms, gym, chess club, arts and crafts club, computer club, and lobby|First Floor (Classrooms) Plan]

[IMAGE:/images/update1-img4-new.jpg|Second floor plan showing banquet hall, kitchen, deck, storage, and cloakroom|Second Floor Plan]

With gratitude and excitement,

**The Armenian School Expansion Committee**
Redmond, Washington`,
  },
];
